<template>
  <div class="entity-doc-image" @click="$emit('click')">
    <p class="entity-doc-image__label">{{ label }}</p>
    <div class="entity-doc-image__frame">
      <v-img :src="src" aspect-ratio="1" contain class="entity-doc-image__img" />
      <div class="entity-doc-image__overlay">
        <v-icon color="white" small>mdi-magnify-plus-outline</v-icon>
        <span>Ampliar</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityDetailDocumentImage",
  props: {
    label: { type: String, required: true },
    src: { type: String, required: true },
  },
});
</script>

<style scoped lang="scss">
.entity-doc-image__label {
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
}

.entity-doc-image__frame {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #f1f5f9;
  cursor: zoom-in;
}

.entity-doc-image__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(15, 23, 42, 0.45);
  color: white;
  font-size: 0.8rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.entity-doc-image__frame:hover .entity-doc-image__overlay {
  opacity: 1;
}
</style>
